import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Resolve image URLs: uploaded images come back as "/api/uploads/xxx"
export const mediaUrl = (url) => {
  if (!url) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
};

// Resized variant (320 / 640 / 960 px wide, WebP) for uploaded images; external URLs are returned as-is
export const thumbUrl = (url, w = 640) => {
  if (!url) return url;
  if (url.startsWith("/api/uploads/")) return `${BACKEND_URL}${url}?w=${w}`;
  return url;
};

const client = axios.create({ baseURL: API, withCredentials: true, headers: { "X-Requested-With": "XMLHttpRequest" } });

// ---- Auth (httpOnly cookie session; nothing is stored in the browser) ----
export const login = async (username, password) => {
  const { data } = await client.post("/auth/login", { username, password });
  return data;
};
export const logout = () => client.post("/auth/logout").then((r) => r.data);
export const getMe = () => client.get("/auth/me").then((r) => r.data);

// ---- Properties ----
export const listProperties = (params = {}) =>
  client.get("/properties", { params }).then((r) => r.data);
export const listAllProperties = () =>
  client.get("/admin/properties").then((r) => r.data);
export const catalogStatus = () => client.get("/admin/catalog/status").then((r) => r.data);
export const catalogImport = () => client.post("/admin/catalog/import").then((r) => r.data);
export const getProperty = (id) => client.get(`/properties/${id}`).then((r) => r.data);
export const createProperty = (payload) => client.post("/properties", payload).then((r) => r.data);
export const updateProperty = (id, payload) => client.put(`/properties/${id}`, payload).then((r) => r.data);
export const updatePropertyStatus = (id, status) =>
  client.patch(`/properties/${id}/status`, { status }).then((r) => r.data);
export const deleteProperty = (id) => client.delete(`/properties/${id}`).then((r) => r.data);
export const listPropertyCategories = () => client.get("/property-categories").then((r) => r.data);

// ---- Formations ----
export const listFormations = () => client.get("/formations").then((r) => r.data);
export const createFormation = (p) => client.post("/formations", p).then((r) => r.data);
export const updateFormation = (id, p) => client.put(`/formations/${id}`, p).then((r) => r.data);
export const deleteFormation = (id) => client.delete(`/formations/${id}`).then((r) => r.data);

// ---- Events ----
export const listEvents = () => client.get("/events").then((r) => r.data);
export const createEvent = (p) => client.post("/events", p).then((r) => r.data);
export const updateEvent = (id, p) => client.put(`/events/${id}`, p).then((r) => r.data);
export const deleteEvent = (id) => client.delete(`/events/${id}`).then((r) => r.data);

// ---- Leads ----
export const createLead = (p) => client.post("/leads", p).then((r) => r.data);
export const listLeads = () => client.get("/leads").then((r) => r.data);
export const getEstimator = () => client.get("/estimator").then((r) => r.data);
export const saveEstimator = (p) => client.put("/admin/estimator", p).then((r) => r.data);
export const resetEstimator = () => client.post("/admin/estimator/reset").then((r) => r.data);
export const sendEmailTest = () => client.post("/admin/email-test").then((r) => r.data);

// ---- Services (rentals & management) ----
// ---- Guesty rentals (live) ----
export const listRentals = () => client.get("/rentals").then((r) => r.data);
export const listAdminRentals = () => client.get("/admin/rentals").then((r) => r.data);
export const setRentalVisibility = (id, hidden) =>
  client.put(`/admin/rentals/${id}/visibility`, { hidden }).then((r) => r.data);
export const getRentalCalendar = (id, start, end) =>
  client.get(`/rentals/${id}/calendar`, { params: { start, end } }).then((r) => r.data);

export const listServices = (params = {}) =>
  client.get("/services", { params }).then((r) => r.data);
export const createService = (p) => client.post("/services", p).then((r) => r.data);
export const updateService = (id, p) => client.put(`/services/${id}`, p).then((r) => r.data);
export const deleteService = (id) => client.delete(`/services/${id}`).then((r) => r.data);

// ---- Upload ----
export const uploadImage = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return client
    .post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
};

export default client;
